import { useNuxtApp } from '#imports'

/**
 * Removes every browsing history entry and notifies the consumers, mirroring
 * what `useRecordVisit` does after storing a visit.
 */
export function useClearBrowsingHistory() {
  const nuxtApp = useNuxtApp()

  async function clearBrowsingHistory() {
    const { clearEntries } = await import('../utils/persistence')

    await clearEntries()
    await nuxtApp.callHook('browsing-history:update')
  }

  return { clearBrowsingHistory }
}
